import {
  Alert,
  Avatar,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Snackbar,
  TextField,
} from "@mui/material";
import { useStyles } from "./ContactStyles";
import colors from "../../themes/colors";
import { styled } from "@mui/material/styles";
import ColorLine from "../../components/ColorLine";
import CommonContentBox from "../../components/CommonContentBox";
import HighlightComponent from "../../components/HighlightComponent";
import ScrollAnimation from "react-animate-on-scroll";
import Product from "../../components/Product";
import { LocalStorage } from "../../cache/localStorage";
import { CompanyKey } from "../../constant";
import { useState } from "react";
import { addDoc, setDoc } from "firebase/firestore/lite";
import { messageColRef } from "../../database/Firebase";
import { Helmet } from "react-helmet";

const CssTextField = styled(TextField)({
  "&:placeholder": {
    color: "white",
  },
  "& label.Mui-focused": {
    color: "white",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "white",
    borderWidth: 0,
    color: "white",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
      borderWidth: 0,
      color: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
      borderWidth: 0,
      color: "white",
    },
    "&:placeholder": {
      color: "white",
    },
    "&.Mui-focused fieldset": {
      borderColor: "white",
      borderWidth: 0,
      color: "white",
    },
  },
});

function ContactComponent() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [Toast, setToast] = useState(false);
  const [contact, setContact] = useState({
    name: "",
    phone: "",
    email: "",
    project: "default",
    message: "",
  });

  const handleChange = (event: any) => {
    console.log("event", event.target.value);

    let value = event.target.value;
    let name = event.target.name;

    setContact((prevalue) => {
      return {
        ...prevalue, // Spread Operator
        [name]: value,
      };
    });
  };

  const handleSubmit = async () => {
    //form validation
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if (contact.name.length <= 2) {
      alert("Please enter valid name");
      return;
    } else if (!contact.phone.match(phoneno)) {
      alert("Please enter valid phone");
      return;
    } else if (!contact.email.match(validRegex)) {
      alert("Please enter valid email");
      return;
    } else if (contact.project === "default") {
      alert("Please select the project !");
      return;
    }
    try {
      const response = await addDoc(messageColRef, {
        id: Date.now().toString(36) + Math.random().toString(36).substr(2),
        ...contact,
        created_at: new Date(),
      });
      console.log("Contact Response", response);
      setToast(true);
      setContact({
        name: "",
        phone: "",
        email: "",
        project: "default",
        message: "",
      });
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Toast}
        onClose={() => {
          setToast(false);
        }}
        message="I love snacks"
        key={"12345678"}
      >
        <Alert
          onClose={() => {
            setToast(false);
          }}
          severity="success"
          sx={{ width: "100%" }}
        >
          Thanks for your message !
        </Alert>
      </Snackbar>
      <section className={classes.bg_image}>
        <div className="marginContainer">
          <Grid
            pt={4}
            pb={20}
            container
            direction={"row"}
            justifyContent={"space-around"}
            alignItems={"flex-start"}
          >
            <Grid item sm={4}>
              <p className={classes.title}>Contact Info</p>
              <p className={classes.subTitle0}>You can contact us anytime !</p>
              <div className={classes.infoWrapper}>
                <div style={{ paddingTop: 30 }}>
                  <img
                    src={require("../../assets/ContactIcons/Icons_Whatsapp.png")}
                    width={50}
                    height={50}
                    alt="juju Designz"
                  />
                </div>
                <div>
                  <p className={classes.headTitle}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: 18,
                      }}
                      href={`https://api.whatsapp.com/send?phone=${
                        LocalStorage.get(CompanyKey)
                          ? LocalStorage.get(CompanyKey).contact.split("-")[1]
                          : "+91-8220010664"
                      }`}
                    >
                      {LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).contact
                        : "+91-8220010664"}
                    </a>
                  </p>
                </div>
              </div>

              <div className={classes.infoWrapper}>
                <div style={{ paddingTop: 30 }}>
                  <img
                    src={require("../../assets/ContactIcons/Icons_Mail.png")}
                    width={50}
                    height={50}
                    alt="juju Designz"
                  />
                </div>
                <div>
                  <p className={classes.headTitle}>
                    <a
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: 18,
                      }}
                      href={
                        LocalStorage.get(CompanyKey)
                          ? LocalStorage.get(CompanyKey).email
                          : "mail2jujudesigns@gmail.com"
                      }
                    >
                      {LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).email
                        : "mail2jujudesigns@gmail.com"}
                    </a>
                  </p>
                </div>
              </div>

              <div className={classes.infoWrapper}>
                <div style={{ paddingTop: 30 }}>
                  <img
                    src={require("../../assets/ContactIcons/Icons_Do.png")}
                    width={50}
                    height={50}
                    alt="juju Designz"
                  />
                </div>
                <div>
                  <p className={classes.headTitle}>Office Hours</p>
                </div>
              </div>
              <p className={classes.subTitle}>Monday - saturday</p>
              <p className={classes.subTitle}>8:30 AM - 9:30 PM </p>
            </Grid>
            <Grid item sm={8}>
              <p className={classes.title}>Send Us Message</p>
              <p className={classes.subTitle0}>Share your queries with us !</p>
              <Grid
                container
                direction="row"
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item sm={6}>
                  <form>
                    <CssTextField
                      name="name"
                      className={classes.InputSpace}
                      fullWidth
                      label="Name"
                      variant="filled"
                      autoComplete={"off"}
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: colors.white,
                        },
                      }}
                      InputProps={{
                        style: {
                          color: colors.white,
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                      onChange={handleChange}
                      value={contact.name}
                    />
                    <CssTextField
                      name="phone"
                      className={classes.InputSpace}
                      autoComplete={"off"}
                      fullWidth
                      variant="filled"
                      label="Phone Number"
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: colors.white,
                        },
                      }}
                      InputProps={{
                        style: {
                          color: colors.white,
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                      onChange={handleChange}
                      value={contact.phone}
                    />

                    <CssTextField
                      name="email"
                      className={classes.InputSpace}
                      autoComplete={"off"}
                      fullWidth
                      variant="filled"
                      label="Email ID"
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: colors.white,
                        },
                      }}
                      InputProps={{
                        style: {
                          color: colors.white,
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                        },
                      }}
                      onChange={handleChange}
                      value={contact.email}
                    />
                  </form>
                </Grid>
                <Grid item sm={5}>
                  <form autoComplete="off">
                    <FormControl
                      variant="standard"
                      style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}
                      fullWidth
                      className={classes.InputSpace}
                    >
                      <Select
                        displayEmpty
                        name="project"
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        label="Project"
                        style={{ color: colors.white, padding: 13 }}
                        // onChange={handleChange}
                        onChange={handleChange}
                        value={contact.project}
                        autoComplete={"off"}
                      >
                        <MenuItem value="default">Select Project</MenuItem>
                        <MenuItem value={"Design/Dev Project"}>
                          Design/Dev Project
                        </MenuItem>
                        <MenuItem value={"Gifts Order"}>Gifts Order</MenuItem>
                        <MenuItem value={"Become a Partner"}>
                          Become a Partner
                        </MenuItem>
                        <MenuItem value={"Sponsor"}>Sponsor</MenuItem>
                        <MenuItem value={"Free Service"}>Free Service</MenuItem>
                      </Select>
                    </FormControl>
                    <CssTextField
                      name="message"
                      className={classes.InputSpace}
                      id="outlined-multiline-static"
                      label="Message"
                      variant="filled"
                      multiline
                      fullWidth
                      rows={5}
                      InputLabelProps={{
                        style: {
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          width: "100%",
                          color: colors.white,
                        },
                      }}
                      InputProps={{
                        style: {
                          color: colors.white,
                          backgroundColor: "rgba(255, 255, 255, 0.1)",
                          border: 0,
                        },
                      }}
                      onChange={handleChange}
                      value={contact.message}
                      autoComplete={"off"}
                    />
                  </form>
                </Grid>
              </Grid>
              <Button
                onClick={() => handleSubmit()}
                className={classes.InputSpace}
                size={"large"}
                style={{
                  background:
                    "linear-gradient(90deg, rgba(102,214,30,1) 0%, rgba(87,178,29,1) 53%)",
                  color: colors.white,
                  textTransform: "capitalize",
                  width: "20%",
                  paddingLeft: 20,
                  paddingRight: 20,
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </section>
      <ColorLine />
      <section>
        <div className="marginContainer">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ textAlign: "center" }}
            pt={10}
            pb={10}
          >
            <ScrollAnimation animateIn="fadeIn">
              <Grid
                sx={{
                  display: { xs: "none", lg: "block" },
                }}
                item
                style={{ textAlign: "center" }}
              >
                <a
                  target="_blank"
                  href={
                    LocalStorage.get(CompanyKey)
                      ? LocalStorage.get(CompanyKey).banner_link
                      : ""
                  }
                >
                  <Avatar
                    variant="square"
                    sx={{ width: "100%", height: 200 }}
                    alt="juju Designz salem"
                    src={
                      LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).adsUrl
                        : ""
                    }
                  />
                </a>
              </Grid>
              <Grid
                sx={{
                  display: { xs: "block", lg: "none" },
                }}
                xs={12}
                item
                style={{ textAlign: "center" }}
              >
                <a
                  target="_blank"
                  href={
                    LocalStorage.get(CompanyKey)
                      ? LocalStorage.get(CompanyKey).banner_link
                      : ""
                  }
                >
                  <Avatar
                    variant="square"
                    sx={{ width: "100%", height: 200 }}
                    alt="juju Designz salem"
                    src={
                      LocalStorage.get(CompanyKey)
                        ? LocalStorage.get(CompanyKey).adsPortraitUrl
                        : ""
                    }
                  />
                </a>
              </Grid>
            </ScrollAnimation>
          </Grid>
        </div>
      </section>

      {/* SEO */}
      <Helmet>
        <title>JuJu Designz Contact</title>
        <meta
          name="description"
          content="JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider  juju designs juju, designsz of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated  juju designs juju, designsz and  juju designs juju, designsz amused to see our customers exhilarated. location : salem , Tamil Nadu , graphics design , web designing , mobile app development . best startup in salem , best web development in salem , juju designs juju, designsz.salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation.JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a >good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,salem,salem,salem,tamil nadu,tamil nadu,tamil nadu,tamil nadu,juju,juju,juju,juju,juju,juju designz,juju designz,juju designz,juju designz,juju designz,juju designs,juju designs,juju designs,juju designs,juju designs,best startup,best startup,best startup,best startup,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,best startup in salem,salem design company,salem design company,salem design company,salem design company, salem juju designz,salem juju designz,salem juju designz,salem juju designzsalem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz,salem juju designz, developmenetdevelopmenet,developmenet,developmenet,developmenet,developmenet,developmenet, IT Company,IT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT CompanyIT Company,IT Company,IT Company,IT Company,IT CompanyIT Company,Salem best company,Salem best company,Salem best companySalem best companySalem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Salem best company,Struggling to find a creative/design solution? Here is a good nes for you! Go through our wide range of services to fulfil your needs, and we get immense pleasure to make it for you. Start exploring JuJu!,Join hands to build your business and turn your brand to become customer's favourite.,We make graphic designs that can be printed on any physical medium, and on the other hand you can also have graphic designs for yor digital purpose across various platforms.,We create brand new product images and also add magic to your existing ones. (or  We add magic to images for every needs.) ,We add creative brand design and make your product packaging & labelling even more interesting to get you uniquely identified among customers.,We make responsive, up-to date and good quality design customized as per your needs. And, we think from the user side for providing great interactive experience in every visit.,Thanks for landing in JuJu's gift store! Hope our creative collectives makes you happy.We Serve Your Dreams (or) We Serve your design ideas (or) WeGive Form to Your Design  (or) We Shape your Imagination/Visualisation,JuJu designz, a young and budding startup fascinated in making adorable creative works ventred on Aug 7 of 2018 and paved our path towards a multi-faceted online service provider of captivating design solutions to make your brand renowned also provide innovative gifting options. We ideate uniqueness in our creative services. We'll be motivated and amused to see our customers exhilarated.,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift StoreJuJu Gift Store,,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store,JuJu Gift StoreJuJu Gift StoreJuJu Gift Store,JuJu Gift Store,JuJu Gift Store"
        />
      </Helmet>
    </>
  );
}

export default ContactComponent;
